/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModuleOutput } from 'src/app/generated/caster-api';

@Component({
    selector: 'cas-module-output',
    templateUrl: './module-output.component.html',
    styleUrls: ['./module-output.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModuleOutputComponent implements OnInit {
  @Input()
  moduleName: string;

  @Input()
  output: ModuleOutput;

  constructor(private snackBar: MatSnackBar) {}

  ngOnInit(): void {}

  toTerraform(): string {
    return `$\{module.${this.moduleName}.${this.output.name}}`;
  }

  onClipboardSuccess() {
    this.snackBar.open(`Copied ${this.toTerraform()} to clipboard`, 'Dismiss');
  }
}
